import { render, staticRenderFns } from "./MarketplacePaymentTerms.vue?vue&type=template&id=037a94be&scoped=true&"
import script from "./MarketplacePaymentTerms.vue?vue&type=script&lang=js&"
export * from "./MarketplacePaymentTerms.vue?vue&type=script&lang=js&"
import style0 from "./MarketplacePaymentTerms.vue?vue&type=style&index=0&id=037a94be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a94be",
  null
  
)

export default component.exports